import { FormControl, FormGroup } from "@angular/forms";
import { BaseObservableForm } from "apps-module/app/shared-library/forms/base-observable.form";
import { nameof } from "apps-module/app/shared-library/utils/common.utils";

import { DateFilterValues } from "../components/date-filter/date-filter-values.enum";
import { FormSearchParametersModel } from "../models/form-search-parameters.model";

export class SearchForm extends BaseObservableForm<FormSearchParametersModel> {
    public static createForm(initialSearchParams: FormSearchParametersModel): SearchForm {
        const formGroup = new FormGroup({
            pageNumber: new FormControl<number>(initialSearchParams.pageNumber),
            homePageId: new FormControl<string>(initialSearchParams.homePageId),
            searchText: new FormControl<string>(initialSearchParams.searchText),
            siteSections: new FormControl<Array<string>>(initialSearchParams.siteSections),
            categories: new FormControl<Array<string>>(initialSearchParams.categories),
            dateFilterType: new FormControl<DateFilterValues>(initialSearchParams.dateFilterType),
            fromDate: new FormControl<string>(initialSearchParams.fromDate),
            toDate: new FormControl<string>(initialSearchParams.toDate)
        });

        return new SearchForm(formGroup, initialSearchParams);
    }

    public get nativeForm(): FormGroup { return this.formInstance; }

    public get pageNumber(): FormControl<number> { return this.formInstance.get(nameof<FormSearchParametersModel>("pageNumber")) as FormControl<number>; }
    public get homePageId(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("homePageId")) as FormControl<string>; }
    public get searchText(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("searchText")) as FormControl<string>; }
    public get siteSections(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("siteSections")) as FormControl<Array<string>>; }
    public get categories(): FormControl<Array<string>> { return this.formInstance.get(nameof<FormSearchParametersModel>("categories")) as FormControl<Array<string>>; }
    public get dateFilterType(): FormControl<DateFilterValues> { return this.formInstance.get(nameof<FormSearchParametersModel>("dateFilterType")) as FormControl<DateFilterValues>; }
    public get fromDate(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("fromDate")) as FormControl<string>; }
    public get toDate(): FormControl<string> { return this.formInstance.get(nameof<FormSearchParametersModel>("toDate")) as FormControl<string>; }

    private constructor(
        formInstance: FormGroup,
        initialSearchParams: FormSearchParametersModel
    ) {
        super(formInstance, initialSearchParams);
    }

    public searchByPageNumber(): void {
        this.submit({
            searchText: this.initialFormState.searchText,
            siteSections: this.initialFormState.siteSections,
            categories: this.initialFormState.categories,
            dateFilterType: this.initialFormState.dateFilterType,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }

    public searchByFilters(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText,
            dateFilterType: this.initialFormState.dateFilterType,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }

    public searchByDates(): void {
        this.submit({
            pageNumber: 1,
            searchText: this.initialFormState.searchText
        });
    }

    public searchByText(): void {
        this.submit({
            pageNumber: 1,
            dateFilterType: this.initialFormState.dateFilterType,
            fromDate: this.initialFormState.fromDate,
            toDate: this.initialFormState.toDate
        });
    }
}
